<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/schedule/job/log/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('renwuzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('shibai')" :value="1"></el-option>
              <el-option :label="$t('chenggong')" :value="0"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc',jobId: yt.conditions.jobId})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>

		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">


		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'admin_global_schedule_log',
		components: {
		},
    props:{
      jobId: '',
    },
		data() {
			return {
				show: false,
				timer: null,
				list: [],

				columns: [{
          label: 'createTime',
          prop: 'createTime',
          type: 'time',
          width: 180
        },{
					label: 'renwuzhuangtai',
					prop: 'status',
          type: 'dictionary',
          key: 'SCHEDULE_JOB_LOG_STATUS',
          width: 100
				}, {
					label: 'shibaixinxi',
					prop: 'error',
				}, {
					label: 'haoshihaomiao',
					prop: 'times',
          width: 180
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
          jobId: this.jobId
				}
				this.yt.get(1);
			}, 300)
		},
		destroyed() {
			clearTimeout(this.timer)
		},
		methods: {

		}
	};
</script>
